<main class="modal">
  <a
    class="link-cancel"
    mat-icon-button
    matTooltip="Cancelar"
    (click)="cancel()"
    matTooltipPosition="left"
  >
    <mat-icon>close</mat-icon>
  </a>
  <div style="overflow-y: hidden; height: calc(90vh - 15rem)">
    <div style="overflow-y: auto; height: 100%">
      <form [formGroup]="formGroup" (ngSubmit)="submit()">
        <div mat-dialog-content class="content">
          <mat-card>
            <div class="row">
              <h5>Relatório de recebíveis</h5>
              <div class="col-12 col-sm-12">
                <mat-card-content *ngIf="selectedStores.length < 1">
                  <mat-form-field class="example-chip-list">
                    <mat-label>Macro grupo</mat-label>
                    <mat-chip-list #chipListMacroGroup>
                      <mat-chip
                        *ngFor="let macroGroup of selectedMacroGroups"
                        [selectable]="false"
                        [removable]="true"
                        (removed)="removeMacroGroup(macroGroup)"
                      >
                        {{ macroGroup.macroName }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip>
                      <input
                        matInput
                        #macroGroupInput
                        [formControl]="macroGroupControl"
                        formControlName="macroGroupsInput"
                        [matAutocomplete]="autoMacroGroup"
                        [matChipInputFor]="chipListMacroGroup"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      />
                    </mat-chip-list>
                    <mat-autocomplete
                      #autoMacroGroup="matAutocomplete"
                      (optionSelected)="selectedMacroGroup($event)"
                    >
                      <mat-option
                        *ngFor="let macroGroup of filteredMacroGroups | async"
                        [value]="macroGroup"
                      >
                        {{ macroGroup.macroName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </mat-card-content>

                <mat-card-content
                  *ngIf="selectedMacroGroups.length < 1 && storeSelected && storesUser.length > 1"
                >
                  <mat-form-field class="example-chip-list">
                    <mat-label>Parceiro</mat-label>
                    <mat-chip-list #chipListStore>
                      <mat-chip
                        *ngFor="let store of selectedStores"
                        [selectable]="false"
                        [removable]="true"
                        (removed)="remove(store)"
                      >
                        {{ store.storeName }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip>
                      <input
                        matInput
                        #storeInput
                        [formControl]="storeControl"
                        formControlName="storesInput"
                        [matAutocomplete]="autoStore"
                        [matChipInputFor]="chipListStore"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      />
                    </mat-chip-list>
                    <mat-autocomplete
                      #autoStore="matAutocomplete"
                      (optionSelected)="selected($event)"
                    >
                      <mat-option *ngFor="let store of filteredStores | async" [value]="store">
                        {{ store.storeName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </mat-card-content>

                <mat-card-content *ngIf="selectedMacroGroups.length < 1 && !storeSelected">
                  <mat-form-field class="example-chip-list">
                    <mat-label>Parceiro</mat-label>
                    <mat-chip-list #chipListStore>
                      <mat-chip
                        *ngFor="let store of selectedStores"
                        [selectable]="false"
                        [removable]="true"
                        (removed)="remove(store)"
                      >
                        {{ store.nomeFantasia }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip>
                      <input
                        matInput
                        #storeInput
                        [formControl]="storeControl"
                        formControlName="storesInput"
                        [matAutocomplete]="autoStore"
                        [matChipInputFor]="chipListStore"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      />
                    </mat-chip-list>
                    <mat-autocomplete
                      #autoStore="matAutocomplete"
                      (optionSelected)="selected($event)"
                    >
                      <mat-option *ngFor="let store of filteredStores | async" [value]="store">
                        {{ store.nomeFantasia }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </mat-card-content>

                <mat-form-field>
                  <input
                    matInput
                    formControlName="beginDate"
                    placeholder="Data Inicial"
                    type="date"
                  />
                  <mat-error *ngIf="formGroup.controls.beginDate?.invalid">
                    {{ errorsService.messageErrorFor(formGroup.controls.beginDate) }}
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput formControlName="endDate" placeholder="Data Final" type="date" />
                  <mat-error *ngIf="formGroup.controls.endDate?.invalid">
                    {{ errorsService.messageErrorFor(formGroup.controls.endDate) }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
        <div mat-dialog-actions>
          <div class="actions">
            <button mat-button class="btn-submit-dark">Exportar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</main>
